<script setup>
import Layout from "../Layouts/Customer.vue";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import MultiSelect from "primevue/multiselect";
import { ref } from "vue";
import { Link, useForm } from "@inertiajs/inertia-vue3";
import { router } from "@inertiajs/vue3";
import Button from "primevue/button";
import { useToast } from "primevue/usetoast";
const props = defineProps([
    'customer',
    'menuItems',
    'programOptions',
    'max2HoursOptions',
    'devices',
]);
const toast = useToast();
const submitting = ref(false)
const form = useForm({
    programs: props.customer.answer?.programs ?? [],
    max_two_hours_per_week: props.customer.answer?.max_two_hours_per_week ?? null,
    months: null,
    devices: props.customer.devices ?? [],
})

const devicesMap = ref({})

for (var i in props.devices) {
    devicesMap.value[props.devices[i].uuid] = props.devices[i]
}

const availableDevices = ref([])

const setAvailableDevices = () => {
    var tempDevicesMap = Object.assign({}, devicesMap.value)

    for (var i in form.devices) {
        var key = form.devices[i].uuid

        delete tempDevicesMap[key]
    }

    availableDevices.value = Object.values(tempDevicesMap).filter(item => item)
}

setAvailableDevices()

const addVisible = ref(false)
const newDevices = ref([])

const addDevices = () => {
    for (var i in newDevices.value) {
        form.devices.push(devicesMap.value[newDevices.value[i]])
    }

    newDevices.value = []

    setAvailableDevices()

    addVisible.value = false
}

const removeDevice = (idx) => {
    form.devices.splice(idx, 1)
    setAvailableDevices()
}

const submit = () => {
    submitting.value = true

    form.post(
        `/customers/${props.customer.uuid}/evaluate`,
        {
            onSuccess: () => {
                toast.add({
                    severity: "success",
                    summary: "Aktualisiert!",
                    life: 5000,
                });
            },

            onFinish: () => {
                submitting.value = false;
            },
        }
    )
}
</script>
<template>
    <Layout :customer="customer" :menu-items="menuItems">
        <div class="p-14 pb-7">
            <h1 class="text-black text-2xl font-regular mb-12">Nach der Auswertung deiner Anamnese empfehlen wir folgende Trainings und Behandlungen</h1>

            <div class="grid grid-cols-3 gap-x-[3em] gap-y-4 mb-12">
                <div>
                    <h4 class="text-black text-sm font-bold">Abo-Programm-Wahl</h4>
                </div>

                <div>
                    <h4 class="text-black text-sm font-bold">Behandlungseinheiten</h4>
                </div>

                <div>
                    <h4 class="text-black text-sm font-bold">Behandlungsdauer</h4>
                </div>

                <div>
                    <MultiSelect v-model="form.programs"
                                 :options="programOptions"
                                 option-label="label"
                                 option-value="value"
                                 class="w-full md:w-14rem" />
                </div>

                <div>
                    <Dropdown v-model="form.max_two_hours_per_week"
                              :options="max2HoursOptions"
                              option-label="label"
                              option-value="value"
                              class="w-full md:w-14rem" />
                </div>

                <div>
                    <Dropdown v-model="form.months"
                              :options="['3 Monate']"
                              class="w-full md:w-14rem" />
                </div>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-0 mb-24">
            <div class="bg-[#EEEBE4]">
                <div class="pl-14 py-3">
                    <h4 class="text-black text-xs font-extralight">Technologie</h4>
                </div>
            </div>

            <div class="bg-[#EEEBE4]">
                <div class="pr-14 py-3">
                    <div class="flex justify-end gap-2">
                        <h4 class="text-black text-xs font-extralight">weitere Behandlung hinzufügen</h4>
                        <i class="pi pi-plus text-[#C5C6CC] cursor-pointer" @click="addVisible = true"></i>
                    </div>
                </div>
            </div>

            <template v-for="(data, idx) in form.devices" :key="idx">
                <div class="border-b border-[#C5C6CC]">
                    <div class="pl-14 py-3">
                        <span class="text-sm">{{ data.name }}</span>
                    </div>
                </div>

                <div class="border-b border-[#C5C6CC]">
                    <div class="pr-14 py-3">
                        <div class="flex gap-3 justify-end">
                            <template v-if="data.pivot?.is_maybe">
                                <i class="pi pi-exclamation-circle text-[#ED3241]"></i>
                                <span class="text-xs font-extralight">Freigabe durch VIGORY nötig</span>
                            </template>

                            <i class="pi pi-trash text-[#C5C6CC] cursor-pointer" @click="removeDevice(idx)"></i>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div class="px-14 pb-14">
            <div class="flex justify-end">
                <Button
                    @click="submit"
                    :loading="submitting"
                    label="speichern"
                    class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                />
            </div>
        </div>

        <Dialog v-model:visible="addVisible"
                header="Gerät hinzufügen"
                :style="{ width: '25rem' }"
                modal>
            <div class="mb-7">
                <MultiSelect v-model="newDevices"
                             :options="availableDevices"
                             option-label="name"
                             option-value="uuid"
                             class="w-full md:w-14rem" />
            </div>

            <div class="flex justify-end gap-2">
                <Button type="button" label="Abbrechen" severity="secondary" @click="addVisible = false"></Button>
                <Button type="button" label="Hinzufügen" @click="addDevices"></Button>
            </div>
        </Dialog>
    </Layout>
</template>
